<h2 class="page-title">
  {{ 'orderHistory.orderDetails' | cxTranslate }}
</h2>
<ng-container *ngIf="order$ | async as order">
  <app-custom-order-ticket-download *ngIf="order.statusDisplay !== 'Cancelado'" [order$]="order$"></app-custom-order-ticket-download>
  <cx-order-overview [order]="order"></cx-order-overview>
</ng-container>
